import './index.css'
import * as React from 'react'
import { connect } from 'react-redux'
import type { State } from 'types/redux'
import { loadBatch } from '@disco/state-management/actions/PlaylistTrackActions'
import api from '@disco/api/server'
import CustomDropdown from 'components/ui/dropdowns/custom-dropdown'
type Option = {
  label: string
  value: number
}
type Options = Option[]

function mapStateToProps(state: State) {
  return {
    csrfToken: state.user.csrfToken,
  }
}

const mapDispatchToProps = {
  loadBatch,
}

class PlaylistSelect extends React.Component<{
  csrfToken: string
  value: (Options | Option) | null | undefined
  multi?: boolean
  onChange: (values: Options | Option) => unknown
  loadBatch: typeof loadBatch
}> {
  _abortController: AbortController | null | undefined

  componentWillUnmount() {
    if (this._abortController) this._abortController.abort()
  }

  _getOptions = async (
    input: string,
    callback: (err: Error | null | undefined, result?: any) => void,
  ) => {
    try {
      if (this._abortController) {
        this._abortController.abort()
      }

      this._abortController = new AbortController()
      const response = await api.getSearchResultsByQuery(
        undefined,
        {
          type: 'playlist',
          q: input,
        },
        undefined,
        this._abortController.signal,
      )
      this.props.loadBatch(response.results)
      const result = {
        options: response.results.map(r => ({
          value: r.playlist_id,
          label: r.name,
        })),
        complete: false, // we never know
      }
      callback(null, result)
    } catch (err) {
      callback(err)
    }
  }

  render() {
    const placeholderText = this.props.multi
      ? 'Choose playlists'
      : 'Choose playlist'
    return (
      <CustomDropdown
        async={true}
        multi={!!this.props.multi}
        clearable={!!this.props.multi}
        loadOptions={this._getOptions}
        value={this.props.value}
        onChange={this.props.onChange}
        placeholder={placeholderText}
      />
    )
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(PlaylistSelect) as any
